import React from "react";
import "./uni.css";
import { useNavigate } from "react-router-dom";


export default function Russia() {
  const Navigate = useNavigate()
  return (
    <div className="vbgy">
      <div className="dfhtu">
        <h2>MBBS in Kazakhstan</h2>
      </div>
      <div className="wityu">
        <img src="https://softamo.org/wp-content/uploads/2021/07/Mbbs-in-Kazakhstan.jpg"></img>

        <p>
          Kazakhstan is the world's largest landlocked country, and the ninth
          largest in the world, with an area of 2,724,900 square kilometers
          (1,052,100 sq mi). It is a transcontinental country largely located in
          Asia; the most western parts are located in Europe. Kazakhstan is the
          domi­nant nation of Central Asia economically, generating 60% of the
          region's GDP, primarily through its oil/gas industry. It also has vast
          mineral resources. The territory of Kazakhstan has historically been
          inhabited by Turkic nomads who trace their ancestry to many Turkic
          states such as Turkic Khaganate etc. In the 13th century, the
          territory joined the Mongolian Empire under Genghis Khan. In 1936, it
          was made the Kazakh Soviet Socialist Republic, part of the Soviet
          Union.
          <br />
          <br />
          <button onClick={()=>{Navigate('/contact')}}>Apply Now</button>
        </p>
      </div>

      {/* 00000000000000000000000000000000000000000000000000000 */}

      <div className="nffd">
        <img src="https://www.piceeducare.com/wp-content/uploads/2019/06/Blog-3.jpg"></img>
        <div className="nhjip">
          <h3
            style={{
              backgroundColor: "#ff9818",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            A BRIEF LOOK AT MBBS IN KAZAKHSTAN
          </h3>
          <br />
          <br />
          <table className="ewrfd">
            <tr>
              <td>Capital</td>
              <td>Nur-Sultan</td>
            </tr>
            <tr>
              <td>Population</td>
              <td>1.88 crores(2020)</td>
            </tr>
            <tr>
              <td>Language</td>
              <td>Kazakh or Qazaq</td>
            </tr>
            <tr>
              <td>Medium of Instruction</td>
              <td>English</td>
            </tr>
            <tr>
              <td>Currency</td>
              <td>Kazakhstani Tenge(1Tenge=0.17 inr)</td>
            </tr>
            <tr>
              <td>International Airport</td>
              <td>Almaty</td>
            </tr>
            <tr>
              <td>Recognition</td>
              <td>NMC (MCI), WHO, ECFMG, FAIMER, WDOMS</td>
            </tr>
            <tr>
              <td>Course Duration</td>
              <td>6 Years(5 + 1 Year's internship)</td>
            </tr>
            <tr>
              <td>Average cost of stay (Fee included)</td>
              <td>15-25 lakhs(Approx)</td>
            </tr>
            <tr>
              <td>Intake</td>
              <td>Summer & Winter</td>
            </tr>
            <tr>
              <td>Accomodation Facilities</td>
              <td>Hostel & Apartment</td>
            </tr>
            <tr>
              <td>Indian Mess</td>
              <td>Available</td>
            </tr>
          </table>
        </div>
      </div>

      {/* 0000000000000000000000000000000000000000000000000000000000000000000000    */}
      <div className="cxdsf">
        <div className="ugvuids">
          <h2>UNIVERSITY OF KAZAKHSTAN</h2>
          <table
            className="table"
            data-aos="zoom-in-up"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            <tr>
              <th className="th title2">UNIVERSITY NAME</th>
              <th className="th title2">TUTION FEE</th>
              <th className="th title2">HOSTAL FEE</th>
              <th className="th title2">OTC</th>
              <th className="th title2">TOTAL IN 1ST YEAR</th>
              <th className="th title2">INCENTIVE</th>
            </tr>
            {/* <!-- 1 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>1.</span>Al-Farebi National University
              </td>
              <td className="td">4600$ </td>
              <td className="td">700$</td>
              <td className="td">2000$</td>
              <td className="td">7300$</td>
              <td className="td">1000$</td>
            </tr>
            {/* <!-- 2 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>2.</span> Astana Medical University
              </td>
              <td className="td">3200$</td>
              <td className="td">800$</td>
              <td className="td">2500$</td>
              <td className="td">6500$</td>
              <td className="td">1000$</td>
            </tr>
            {/* <!-- 3 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>3.</span> Kazakh National University
              </td>
              <td className="td">4500$</td>
              <td className="td">320&</td>
              <td className="td">2000$</td>
              <td className="td">6820$</td>
              <td className="td">1000$ </td>
            </tr>

            {/* <!-- 4 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>4.</span> Kokshetau State University
              </td>
              <td className="td">3700$</td>
              <td className="td">500&</td>
              <td className="td">2500$</td>
              <td className="td">6800$</td>
              <td className="td">1000$ </td>
            </tr>

            {/* <!-- 5 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>5.</span> North Kazakhstan state University
              </td>
              <td className="td">-</td>
              <td className="td">-</td>
              <td className="td">-</td>
              <td className="td">-</td>
              <td className="td">- </td>
            </tr>

            {/* <!-- 6 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>6.</span> Semey State Medical University
              </td>
              <td className="td">3800$</td>
              <td className="td">800&</td>
              <td className="td">2100$</td>
              <td className="td">6700$</td>
              <td className="td">1000$ </td>
            </tr>

            {/* <!-- 7 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>7.</span> South Kazakhstan Medical Academy
              </td>
              <td className="td">4200$</td>
              <td className="td">800&</td>
              <td className="td">2000$</td>
              <td className="td">7000$</td>
              <td className="td">800$ </td>
            </tr>

            {/* <!-- 8 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>8. </span> UIB International Medical School in Almaty{" "}
              </td>
              <td className="td">3900$</td>
              <td className="td">2000$ (food included)</td>
              <td className="td">2000$</td>
              <td className="td">7900$</td>
              <td className="td">1000$ </td>
            </tr>
            {/* <!-- 9 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>9. </span> West Kazakhstan Medical University
              </td>
              <td className="td">3700$</td>
              <td className="td">500&</td>
              <td className="td">2500$</td>
              <td className="td">6700$</td>
              <td className="td">800$ </td>
            </tr>
          </table>
        </div>
      </div>
      <section className="ugvui">
        <ul>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Above Mentioned Tution Fee Changable According to Their Academic
            Session.
          </li>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Admission Fee, Documentation & VISA Processing will be 30 to 35,000.
          </li>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Form 2nd to 6th year's Medical Insurance & VISA Extension will be
            Extra (200$).
          </li>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Flight Ticket Charge Excluded.
          </li>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Indian Mess Food 120$ Per Month Extra.
          </li>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            <span>
              <b>Note:</b>
            </span>
            <br />
            In certain case students have to pay either partial or full amount
            of tuition fee to the university soon after receive letter, as per
            the University instruction
          </li>
        </ul>
      </section>

      {/* 0000000000000000000000000000000000000000000000000000000000000000000000 */}

      <div className="gsfas">
        <h3>SEMEY STATE MEDICAL UNIVERSITY</h3>

        <div className="sdgdfghf">
          <img src="https://www.rmcedu.com/images/kazakhstan/semey_1.jpg"></img>
          <p>
            Samarkand State Medical Institute is the first institute of central
            Asia founded in 1930 and situated in Samarkand, Uzbekistan. It is
            one of the largest Institutes counted amongst the NMC approved
            universities of Uzbekistan, definitely a better option for worldwide
            medical aspi­ rants for doing MBBS.
            <br />
            <strong>ESTO. : 1930</strong>
            <br />
            <strong>University Type : Government</strong>
            <br />
            <strong>Medium : English</strong>
            <br />
            <strong>ESTO. : No. of Indian Students : 500+</strong>
            <br />
          </p>
        </div>
      </div>

      {/* 0000000000000000000000000000000000000000000000000 */}

      <div className="packageForFirstYear">
      <h1 className="title">UNIVERSITY OF KAZAKHSTAN</h1><br/><br/>
        <table className="table fgjhfghfg" border="1">
          <h2 style={{ textAlign: "center", width: "100%" }}>
            PACKAGE FOR 1ST YEAR STUDENT
          </h2>
          <thead>
          <tr >
                        <td className="td">TUITION FEE</td>
                        <td className="td">HOSTEL FEE</td>
                        <td className="td td2">IMMIGRATION CLERANCE,AIRPORT PICKUP, ARRIVAL MEAL, TRANSLATION AND ATTESTATION OF DOCUMENTS IN UNIVERSITY, MEDICAL INSURANCE & MEDICAL CHECKUP, LOCAL POLICE VERIFICATION, BIOMETRIC AND VISA EXTENTION, HOSTEL ALLOTMENT, BANK ACCOUNT OPENING, LOCAL SUPPORT ETC</td>
                        <td className="td">TOTAL FEE</td>
                        <td className="td">INCENTIVE</td>
                    </tr>
                    {/* <!-- 2 --> */}
                    <tr> 
                        <td className="td">3800$</td>
                        <td className="td">800$</td>
                        <td className="td">2100$</td>
                        <td className="td">6700$</td>
                        <td className="td">1000$</td>
                    </tr>
          </thead>
        </table>
        <p className="para border">FOOD FEE PER MONTH - 120$ (COMPULSORY)</p>
                <p className="para border pb0">ADMISSION FEE, VISA PROCESSING & DOCUMENTATION <br/> ( 30-35000) | FLIGHT TICKET AS PER ACTUAL.</p>
      </div>

      {/* 000000000000000000000000000000000000000000000000000000000000000 */}

      <div
        className="packageForSixYear"
        data-aos="zoom-out"
        data-aos-duration="1000"
        data-aos-easing="linear"
      >
        <h3 className="packagewhite">PACKAGE FOR 2ND TO 6TH YEAR STUDENT</h3>
        <table className="table">
        <thead>
                    <tr>
                    <th className="th title2">Package</th>
                    <th className="th title2">2nd</th>
                    <th className="th title2">3rd</th>
                    <th className="th title2">4th</th>
                    <th className="th title2">5th</th>
                    <th className="th title2">6th</th>
                </tr>
                {/* <!-- 1 --> */}
                <tr>
                    <td className="td ">Tuition Fee</td>
                    <td className="td">3800$</td>
                    <td className="td">3800$</td>
                    <td className="td">3800$</td>
                    <td className="td">3800$</td>
                    <td className="td">3800$</td>
                </tr>
                {/* <!-- 2 --> */}
                <tr>
                    <td className="td">Hostel Fee</td>
                    <td className="td">800$</td>
                    <td className="td">800$</td>
                    <td className="td">800$</td>
                    <td className="td">800$</td>
                    <td className="td">800$</td>
                </tr>
                {/* <!-- 3 --> */}
                <tr>
                    <td className="td ">Medical Insurance VISA Extention </td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                </tr>
                </thead>
        </table>
      </div>

      <div className="mainSec">
        <ul>
        <li className="para"><span> IMPORTANT NOTE <b>:</b></span><br/><br/>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                    The university is recognized by WHO and NMC.<br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">   
                    The university has very low fee structure for MBBS study and the cost of living is also very low. <br/>
                    </p>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                    The course is taught in English language completely. <br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">
                    The emphasis is given on practical knowledge than just theoretical study.  <br/>
                    </p>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                    There is a moderate climate in Semipalatinsk for the whole year.<br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">
                    Students can get permanent residency and they can plan to settle in Kazakhstan after completing their degree from Kazakhstan.
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">
                    The faculties at this university are the best faculties and thus the quality of education is best.
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">At Semey or Semey State Medical University, good hostel and mess facilities are available for students.</p>
                </li>
        </ul>
      </div>
    </div>
  );
}
